import { axiosInstance, BASE_URL } from "../axios_Instanse";

import Store from "../Store";
import { authLessAxios } from "./AuthLessAxios";

import {
  authUnauthorizedMessage,
  // currentOffice,
  getRecoverCode,
  officeAuth as set_office_auth,
  setCaptchaCode,
  setLoginOTP,
  setLoginRecoverContact,
  setRegisterAddress,
  setRegisterOTP,
  setRegisterStage,
  setResetCaptcha,
  setTraceCode,
} from "./LoginActionCreators";
import { popupMessagesHandler } from "../General/generalActionCreators";
import { get_publisher_state } from "../General/generalActions";
import axios from "axios";

export const setAuthToken = async (values) => {
  const { officeAuth } = Store.getState().loginReducer;
  try {
    Store.dispatch(authUnauthorizedMessage(null));

    // THIS IS FOR DEVELOPMENT ONLY
    const loginData = await axiosInstance.post("/login", {
      ...values,
    });
    ["token", "profile", "recall_interval_timer", "menu", "timeout"].forEach(
      (item) => {
        localStorage[item] =
          item === "menu" || item === "profile"
            ? JSON.stringify(loginData.data[item])
            : loginData.data[item];
      }
    );
    await get_publisher_state();
    axiosInstance.defaults.headers["token"] = loginData.data.token;
    Store.dispatch(set_office_auth(!officeAuth));
    // Store.dispatch(currentOffice("loginData.data.board_title"));
    return "loginData.data";
  } catch (err) {
    const { resetCaptcha } = Store.getState().loginReducer;
    Store.dispatch(setResetCaptcha(resetCaptcha + 1));
  }
};

export const SubmitRegister = async (value) => {
  const { resetCaptcha } = Store.getState().loginReducer;
  try {
    await authLessAxios.post("/try_register", {
      "g-recaptcha-response": Store.getState().loginReducer.captchaCode,
      ...value,
    });
    // Store.dispatch(setResetCaptcha(resetCaptcha + 1));
    Store.dispatch(setRegisterOTP("get"));
    // Store.dispatch(setCaptchaCode(""));
    return true;
  } catch (error) {
    Store.dispatch(setResetCaptcha(resetCaptcha + 1));
  }
};

export const confirm_register = async (values) => {
  try {
    await authLessAxios.post("/confirm_try_register", {
      username: Store.getState().loginReducer.Register_Mobile_Email,
      ...values,
    });
    Store.dispatch(setRegisterStage(1));
    Store.dispatch(setRegisterOTP("come"));
    return true;
  } catch (error) {
    const { resetCaptcha } = Store.getState().loginReducer;
    Store.dispatch(setResetCaptcha(resetCaptcha + 1));
  }
};

export const submitRegisterStages = async (value) => {
  const username = Store.getState().loginReducer.Register_Mobile_Email;
  try {
    const { lat, lng } = Store.getState().loginReducer.lat_lng;

    const submit = await authLessAxios.post("/register", {
      username,
      lat,
      lng,
      ...value,
    });

    Store.dispatch(setTraceCode(submit.data));
    Store.dispatch(setRegisterStage(4));
  } catch (error) {}
};

export const getRegisterAddress = async (values) => {
  try {
    const data = await authLessAxios.get(
      `/point_to_address?lat=${values[0].lat}&lng=${values[0].lng}&username=${values[1]}`
    );

    Store.dispatch(
      setRegisterAddress({
        address: data.data.descr,
        district: data.data.district,
        city: data.data.city,
        province: data.data.state,
      })
    );
  } catch (error) {}
};

export const recoverPassWord = async (values) => {
  try {
    let { data } = await authLessAxios.post("/try_forget_pass", {
      ...values,
    });
    Store.dispatch(setLoginRecoverContact(values.username));
    Store.dispatch(getRecoverCode(2));
    return data;
  } catch (error) {}
};

export const confirm_forget = async (values) => {
  const username = Store.getState().loginReducer.recoverLoginContact;
  try {
    await authLessAxios.post(`/confirm_forget`, {
      username,
      ...values,
    });
    Store.dispatch(setLoginOTP(values));
    Store.dispatch(getRecoverCode(3));
    Store.dispatch();
    Store.dispatch(setCaptchaCode(""));
  } catch (error) {}
};

export const ResetPassword = async (value) => {
  const username = Store.getState().loginReducer.recoverLoginContact;
  try {
    const data = await authLessAxios.post("/reset_password", {
      username,
      ...value,
    });
    Store.dispatch(authUnauthorizedMessage(data.data));
    Store.dispatch(
      popupMessagesHandler({
        mode: true,
        message: data.data,
        color: "info",
      })
    );
    return data;
  } catch (error) {}
};

export const LogOut = async () => {
  try {
    await axiosInstance.post("/logout", {});
    // closeSocket();
    return true;
  } catch (error) {}
};

export const edit_personal_profile = async (value) => {
  try {
    let { data } = await axiosInstance.post("/profile", value);

    Store.dispatch(
      popupMessagesHandler({
        mode: true,
        message: data,
        color: "success",
      })
    );
    return data;
  } catch (error) {}
};
// -----------------------------------------------------------------------------------------------custom captcha code
export const customCaptchaCode = async (old_code) => {
  try {
    const { data } = await axios.get(
      `${
        //  localStorage.MULTI_SERVER_URL
        BASE_URL()
      }/captcha${old_code ? "?old_code=" + old_code : ""}`
    );
    return data;
  } catch (error) {}
};
